export default "__VITE_ASSET__C3SF2qz3__"